/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgJoinRequestItem
 */
export interface OrgJoinRequestItem {
    /**
     * 
     * @type {string}
     * @memberof OrgJoinRequestItem
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgJoinRequestItem
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgJoinRequestItem
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgJoinRequestItem
     */
    phone_number: string;
    /**
     * 
     * @type {number}
     * @memberof OrgJoinRequestItem
     */
    requested_timestamp: number;
}

/**
 * Check if a given object implements the OrgJoinRequestItem interface.
 */
export function instanceOfOrgJoinRequestItem(value: object): value is OrgJoinRequestItem {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('requested_timestamp' in value) || value['requested_timestamp'] === undefined) return false;
    return true;
}

export function OrgJoinRequestItemFromJSON(json: any): OrgJoinRequestItem {
    return OrgJoinRequestItemFromJSONTyped(json, false);
}

export function OrgJoinRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgJoinRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'requested_timestamp': json['requested_timestamp'],
    };
}

export function OrgJoinRequestItemToJSON(json: any): OrgJoinRequestItem {
    return OrgJoinRequestItemToJSONTyped(json, false);
}

export function OrgJoinRequestItemToJSONTyped(value?: OrgJoinRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'requested_timestamp': value['requested_timestamp'],
    };
}

